import React, { useCallback } from 'react';
import { SETTING } from 'interfaces/settings';
import { getSelectConfig } from './selectConfig';
import { useAutodialerSettings } from '../../hooks/useAutodialerSettings';
import { CustomDropdown, CleanSelectOption } from 'utils/CommonUIComponents';

export function SelectSettingControl({ setting }: { setting: SETTING }) {
    const { getValueForSetting, updateSetting } = useAutodialerSettings();
    const config = getSelectConfig(setting);
    const value = getValueForSetting(setting);
    const currentValue = (value as string) || config.defaultValue;
    
    const onChange = useCallback((newValue: string | number) => {
        updateSetting(setting, newValue.toString());
    }, [setting, updateSetting]);
    
    // Convert config options to CleanSelectOption format
    const options: CleanSelectOption[] = config.options.map(option => ({
        value: option.value,
        label: option.label
    }))
    
    return (
        <div className="flex items-center gap-2 flex-1 h-full">
            <CustomDropdown
                value={currentValue}
                onChange={onChange}
                options={options}
                className="flex-1"
            />
        </div>
    );
} 